import { FormLayout } from "../../../../layouts/form";
import { Grid, TextField, IconButton, FormControl, List, ListItem, ListItemText, Autocomplete, Paper, Tooltip, OutlinedInput, InputLabel } from "@mui/material";
import { IMaskInput } from 'react-imask';
import CircularProgress from '@mui/material/CircularProgress';
import { useEffect, useState, Fragment, forwardRef } from "react";
import { CompaniesService } from "../../../../services/companies";
import { NotificationManager } from "react-notifications";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { Button, Upload } from "antd";
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { AccordionForms } from "../../../../components/accordionForms";

function isValidCNPJ(cnpj) {
    var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
    var c = String(cnpj).replace(/[^\d]/g, '')

    if (c.length !== 14)
        return false

    if (/0{14}/.test(c))
        return false

    for (var i = 0, n = 0; i < 12; n += c[i] * b[++i]);
    if (c[12] != (((n %= 11) < 2) ? 0 : 11 - n))
        return false

    for (var i = 0, n = 0; i <= 12; n += c[i] * b[i++]);
    if (c[13] != (((n %= 11) < 2) ? 0 : 11 - n))
        return false

    return true
};

const TextMaskCNPJ = forwardRef(function TextMaskCNPJ(props, ref) {
    const { onChange, ...other } = props;


    return (
        <IMaskInput
            {...other}
            mask="00.000.000/0000-00"
            inputRef={ref}
            onAccept={(value) => {
                if (!isValidCNPJ(value) && value.length === 18) {
                    NotificationManager.error('O CNPJ informado é inválido.', "", 3000);
                }
                onChange({ target: { name: props.name, value } })
            }}
            overwrite
        />
    );
});

export const CompanyForm = ({ onClose, defaultValues }) => {

    const [saving, setSaving] = useState(false);
    const [showPlant, setShowPlant] = useState(defaultValues ? true : false);
    const [showTypeOperation, setShowTypeOperation] = useState(defaultValues ? true : false);
    const [disableSaveButton, setDisableSaveButton] = useState(false);
    const companiesService = new CompaniesService();
    const [listTypesOperation, setListTypesOperation] = useState(defaultValues ? defaultValues.typesOperation : []);
    const [typeOperation, setTypeOperation] = useState('');
    const [listPlants, setListPlants] = useState(defaultValues ? defaultValues.blueprint : []);
    const [plant, setPlant] = useState('');
    const [complement, setComplement] = useState('');
    const [inputValue, setInputValue] = useState("");
    const [inputValuePlant, setInputValuePlant] = useState("");
    const [inputValueComplement, setInputValueComplement] = useState("");
    const [fileList, setFileList] = useState();
    const [listCompanies, setListCompanies] = useState([]);
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [cnpj, setCnpj] = useState(defaultValues ? cnpjMask(defaultValues.cnpj) : "");
    const cidades = require('../form/cidades.json');
    const typeOperationOptions = ["OVOS", "PINTOS", "EMBRIÕES", "GRANJAS", "TODOS"]
    // const typeOperationOptions = ["OVOS", "PINTOS", "SALA1", "SALA2", "SALA3", "SALA4", "EMBRIÕES", "TODOS"]

    function sleep(duration) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, duration);
        });
    }

    useEffect(() => {
        getCompanies();
    }, []);

    const handleCreationSuccess = () => {
        NotificationManager.success('Empresa criada com sucesso.', "", 3000);
        getCompanies();
        setSaving(false);
        setDisableSaveButton(false);
        onClose();
    }

    const handleUpdateSuccess = () => {
        NotificationManager.success('Informações da empresa atualizadas com sucesso.', "", 3000);
        setSaving(false);
        setDisableSaveButton(false);
        onClose();
    }

    const getCompanies = () => {
        companiesService.getCompanies().then((response) => {
            setListCompanies(response.data);
        })
            .catch((error) => {
            });
    }

    /**
     * Save a new company
     */
    const handleSaveClick = (formData) => {
        const data = new FormData(formData);

        const name = data.get('name');
        const cnpj = data.get('cnpj');
        const list = listTypesOperation;
        const plants = listPlants;
        if (!validateFields(name, cnpj)) {
            setSaving(false);
            setDisableSaveButton(false);
            return;
        }

        setSaving(true);

        if (defaultValues) {
            let updatedCompany = {};
            if (fileList) {
                updatedCompany = {
                    "name": name,
                    "cnpj": cnpj,
                    "typesOperation": list,
                    "blueprint": plants,
                    "name_logo": fileList.name,
                    "id": defaultValues.id

                };
            } else {
                updatedCompany = {
                    "name": name,
                    "cnpj": cnpj,
                    "typesOperation": list,
                    "blueprint": plants,
                    "id": defaultValues.id
                };
            }
            companiesService.updateCompany(updatedCompany).then(() => {
                handleUpdateSuccess();
            }).catch((error) => {
                if (error.status === 409) {
                    NotificationManager.error(error.response.data, "", 3000)
                }
                setSaving(false);
                setDisableSaveButton(false);
            });

        } else {
            let newCompany = {}
            if (fileList) {
                newCompany = {
                    "name": name,
                    "cnpj": cnpj,
                    "typesOperation": list,
                    "blueprint": plants,
                    "name_logo": fileList.name
                };
            } else {
                newCompany = {
                    "name": name,
                    "cnpj": cnpj,
                    "typesOperation": list,
                    "blueprint": plants,
                };
            }

            companiesService.createCompany(newCompany)
                .then(() => {
                    if (!fileList) {
                        companiesService.saveFileLogo(fileList).then((response) => {
                            handleCreationSuccess();
                        }).catch((error) => {
                            console.error(error);
                        });
                    } else {
                        handleCreationSuccess();
                    }

                })
                .catch((error) => {
                    if (error.status === 409) {
                        NotificationManager.error(error.response.data, "", 3000)
                    }
                    setSaving(false);
                    setDisableSaveButton(false);
                });
        }
    }

    const handleAddTypesOperations = () => {
        if (typeOperation != null && typeOperation !== "") {
            if(listTypesOperation.includes(typeOperation)) {
                NotificationManager.warning('Operação já adicionada!', "", 3000);
            } else {
                const list = [...listTypesOperation, typeOperation];
                setListTypesOperation(list);
                if (list.length !== 0) {
                    setShowTypeOperation(true);
                }
            }
            setInputValue("");
            setTypeOperation("");
        }
    }

    const handleRemoveTypeOperationList = (indexToRemove) => {
        const updatedList = listTypesOperation.filter((_, index) => index !== indexToRemove);
        setListTypesOperation(updatedList);
        if (updatedList.length === 0) {
            setShowTypeOperation(false);
        }
    }

    const handleInputChange = (newValue) => {
        if(newValue !== null) {
            setInputValue(newValue.toUpperCase());
            setTypeOperation(newValue.toUpperCase());
        } else {
            setInputValue("");
            setTypeOperation("");
        }
    }

    const handleAddPlant = () => {
        if (plant != null && plant !== "") {
            const plants = [...listPlants, plant + complement];
            setListPlants(plants);
            setInputValuePlant("");
            setInputValueComplement("");
            setComplement("");
            setPlant("");
            if (plants.length !== 0) {
                setShowPlant(true);
            }
        }
    }

    const handleRemovePlantList = (indexToRemove) => {
        const updatedList = listPlants.filter((_, index) => index !== indexToRemove);
        setListPlants(updatedList);
        if (updatedList.length === 0) {
            setShowPlant(false);
        }
    }

    const handleInputChangePlant = (event, value) => {
        if (value != null && value !== "") {
            setInputValuePlant(value.label.toUpperCase());
            setPlant(value.label.toUpperCase());
        } else {
            setInputValuePlant("");
            setPlant("");
        }
    }

    const handleInputChangeComplement = (event) => {
        if (event.target.value !== "") {
            setInputValueComplement(event.target.value.toUpperCase());
            setComplement(", " + event.target.value.toUpperCase());
        } else {
            setInputValueComplement("");
            setComplement("");
        }
    }

    const formatInputComplement = (event) => {
        let temp = event.target.value;
        temp = temp.trim();
        event.target.value = temp;
        handleInputChangeComplement(event);
    }

    const handleOpen = () => {
        setOpen(true);
        (async () => {
            setLoading(true);
            await sleep(20);
            setLoading(false);

            setOptions([...cidades.cidades]);
        })();
    };

    const handleClose = () => {
        setOpen(false);
        setOptions([]);
    };

    /*
     * Validate the fields
     * @returns 
     */
    function validateFields(name, cnpj) {
        let hasError = true;

        if (name === "" || cnpj === "") {
            NotificationManager.warning('É preciso preencher todos os campos.', "", 3000);
            hasError = false;
        } else if (!cnpj.match(/\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}/)) {
            NotificationManager.error('O CNPJ informado é inválido.', "", 3000);
            hasError = false;
        } else if (!isValidCNPJ(cnpj)) {
            NotificationManager.error('O CNPJ informado é inválido.', "", 3000);
            hasError = false;
        }

        return hasError;
    }

    const formatInput = (event) => {
        let temp = event.target.value;
        temp = temp.trim();
        event.target.value = temp;
    }

    const handleAddFile = (file) => {
        setFileList(file);
        return false;
    }

    /**
     * Function to create CNPJ mask
     * @param {string with cnpj} value 
     * @returns formatted cnpj
     */
    function cnpjMask(value) {
        return value
            .replace(/\D+/g, '') // não deixa ser digitado nenhuma letra
            .replace(/(\d{2})(\d)/, '$1.$2') // captura 2 grupos de número o primeiro com 2 digitos e o segundo de com 3 digitos, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de número
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1/$2') // captura 2 grupos de número o primeiro e o segundo com 3 digitos, separados por /
            .replace(/(\d{4})(\d)/, '$1-$2')
            .replace(/(-\d{2})\d+?$/, '$1') // captura os dois últimos 2 números, com um - antes dos dois números
    }

    const styleButton = (width) => {
        return ({
            boxShadow: '1px 1px 3px 1px rgb(161, 161, 161)',
            borderRadius: '5px',
            color: "white",
            backgroundColor: "#149925",
            borderColor: "#149925",
            width: width,
            height: '35px',
        });
    }

    const styleBorderField = (width) => {
        return ({
            boxShadow: '1px 1px 3px 1px rgb(217, 217, 217)',
            borderRadius: '6px',
            width: width,
        });
    }

    return (
        <FormLayout onSaveClick={handleSaveClick} saving={saving} disableButton={disableSaveButton}>
            <Grid container spacing={2}>
                <Grid item xs={12} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <Grid xs={6} >
                        <TextField
                            label="Nome Fantasia"
                            id="name"
                            name="name"
                            required
                            variant="outlined"
                            defaultValue={defaultValues ? defaultValues.name : ""}
                            size="small"
                            sx={styleBorderField(400)}
                            onBlur={formatInput}

                        />
                    </Grid>
                    <Grid xs={4}>
                        <FormControl id="cnpj" variant="outlined" required size="small" sx={{ borderRadius: '6px', width: 220 }}>
                            <InputLabel id="cnpj" htmlFor="cnpj">CNPJ</InputLabel>
                            <OutlinedInput
                                label="CNPJ"
                                id="cnpj"
                                name="cnpj"
                                value={cnpj}
                                onChange={(e) => setCnpj(e.target.value)}
                                required
                                size='small'
                                sx={styleBorderField(220)}
                                inputComponent={TextMaskCNPJ}
                            />
                        </FormControl>
                    </Grid>
                    <Grid xs={2} marginRight={'28px'} > </Grid>

                </Grid>
                <Grid item xs={12} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <Grid xs={6}>
                        <FormControl fullWidth variant="outlined" required>
                            <Autocomplete
                                open={open}
                                onOpen={handleOpen}
                                onClose={handleClose}
                                loading={loading}
                                loadingText={"Carregando..."}
                                options={options}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Planta"
                                    slotprops={{
                                        input: {
                                            ...params.InputProps,
                                            endAdornment: (
                                                <Fragment>
                                                    {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                    {params.InputProps.endAdornment}
                                                </Fragment>
                                            ),
                                        },
                                    }}
                                />}
                                id="plant"
                                fullWidth
                                onChange={handleInputChangePlant}
                                value={inputValuePlant}
                                size='small'
                                sx={styleBorderField(400)}
                            />
                        </FormControl>
                    </Grid>
                    <Grid xs={4} >
                        <FormControl id="complement" variant="outlined" size="small" sx={{ borderRadius: '6px', width: 220 }}>
                            <InputLabel id="complement" htmlFor="complement">Complemento</InputLabel>
                            <OutlinedInput
                                label="Complemento"
                                id="complement"
                                name="complement"
                                onChange={handleInputChangeComplement}
                                onBlur={formatInputComplement}
                                value={inputValueComplement}
                                size='small'
                                sx={styleBorderField(220)}
                            />
                        </FormControl>

                    </Grid>
                    <Grid xs={2} marginRight={'25px'} >
                        <Tooltip title="Adicionar Planta" >
                            <Button
                                aria-label='plant'
                                onClick={handleAddPlant}
                                size="small"
                                style={styleButton(170)}

                            >
                                Adicionar Planta <PlusOutlined style={{ fontSize: '20px' }} />
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid>
                {showPlant && <Grid item xs={12} display={'flex'}  >
                    {defaultValues ?
                        <AccordionForms
                            title="Plantas Adicionadas"
                            width={870}
                            height={"90px"}
                            children={
                                <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                    {
                                        listPlants.map((element, index) => {
                                            return (
                                                <Paper elevation={3} variant="outlined" style={{ marginRight: "5px", marginTop: '2px', borderRadius: '32px', borderWidth: 2 }}>
                                                    <ListItem
                                                        secondaryAction={
                                                            <IconButton
                                                                edge="end"
                                                                aria-label="delete"
                                                                onClick={() => handleRemovePlantList(index)}
                                                                style={{ backgroundColor: 'rgb(251, 191, 180)', height: '20px', width: '20px' }}
                                                            >
                                                                <DeleteRoundedIcon color="error" fontSize={'small'} />
                                                            </IconButton>
                                                        }
                                                    >
                                                        <ListItemText
                                                            primary={element}
                                                            disableTypography={true}
                                                            style={{ fontSize: '10px' }}
                                                        />
                                                    </ListItem>
                                                </Paper>
                                            )
                                        })
                                    }
                                </List>
                            }

                        />
                        :
                        <AccordionForms
                            title={"Plantas Adicionadas"}
                            width={870}
                            height={"90px"}
                            children={
                                <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                    {
                                        listPlants.map((element, index) => {
                                            return (
                                                <Paper elevation={3} variant="outlined" style={{ marginRight: "5px", marginTop: '2px', borderRadius: '32px', borderWidth: 2, height: '30px', display: 'flex', alignItems: 'center' }}>
                                                    <ListItem
                                                        secondaryAction={
                                                            <IconButton
                                                                edge="end"
                                                                aria-label="delete"
                                                                onClick={() => handleRemovePlantList(index)}
                                                                style={{ backgroundColor: 'rgb(251, 191, 180)', height: '20px', width: '20px' }}
                                                            >
                                                                <DeleteRoundedIcon color="error" fontSize={'small'} />
                                                            </IconButton>
                                                        }
                                                    >
                                                        <ListItemText
                                                            primary={element}
                                                            disableTypography={true}
                                                            style={{ fontSize: '10px' }}
                                                        />
                                                    </ListItem>
                                                </Paper>
                                            )
                                        })
                                    }
                                </List >
                            }
                        />
                    }
                </Grid>}
                <Grid item xs={12} display={'flex'} flexDirection={'row'} alignItems={'center'}>
                    <Grid xs={10}>
                        <FormControl fullWidth variant="outlined">
                            <Autocomplete
                                label="Tipo de Operação"
                                id="typeOperation"
                                name="typeOperation"
                                variant="outlined"
                                onChange={(event, newValue) => handleInputChange(newValue)}
                                renderInput={(params) => <TextField {...params} label="Tipo de Operação" />}
                                defaultValue={defaultValues ? defaultValues : ''}
                                options={typeOperationOptions}
                                value={inputValue}
                                size='small'
                                sx={styleBorderField(635)}

                            />
                        </FormControl>
                    </Grid>
                    <Grid xs={2} marginRight={'25px'}>
                        <Tooltip title="Adicionar Operação">
                            <Button
                                aria-label='type Operation'
                                onClick={handleAddTypesOperations}
                                color="success"
                                size="small"
                                style={styleButton(170)}

                            >
                                Adicionar Operação <PlusOutlined style={{ fontSize: '20px' }} />
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid>
                {showTypeOperation && <Grid item xs={12} display={'flex'} >
                    {defaultValues ?
                        <AccordionForms
                            title={"Tipos de Operação Adicionados"}
                            width={870}
                            height={"90px"}
                            children={
                                <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                    {
                                        listTypesOperation.map((element, index) => {
                                            return (
                                                <Paper elevation={3} variant="outlined" style={{ marginRight: "5px", marginTop: '2px', borderRadius: '32px', borderWidth: 2 }}>
                                                    <ListItem
                                                        secondaryAction={
                                                            <IconButton
                                                                edge="end"
                                                                aria-label="delete"
                                                                onClick={() => handleRemoveTypeOperationList(index)}
                                                                style={{ backgroundColor: 'rgb(251, 191, 180)', height: '20px', width: '20px' }}
                                                            >
                                                                <DeleteRoundedIcon color="error" fontSize={'small'} />
                                                            </IconButton>
                                                        }
                                                    >
                                                        <ListItemText
                                                            primary={element}
                                                            disableTypography={true}
                                                            style={{ fontSize: '10px' }}
                                                        />
                                                    </ListItem>
                                                </Paper>
                                            )
                                        })
                                    }
                                </List>
                            }
                        />
                        :
                        <AccordionForms
                            title={"Tipos de Operação Adicionados"}
                            width={870}
                            height={"90px"}
                            children={
                                <List dense style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                    {
                                        listTypesOperation.map((element, index) => {
                                            return (
                                                <Paper
                                                    elevation={3}
                                                    variant="outlined"
                                                    style={{
                                                        marginRight: "5px",
                                                        marginTop: '2px',
                                                        borderRadius: '32px',
                                                        borderWidth: 2
                                                    }}>
                                                    <ListItem
                                                        secondaryAction={
                                                            <IconButton
                                                                edge="end"
                                                                aria-label="delete"
                                                                onClick={() => handleRemoveTypeOperationList(index)}
                                                                style={{ backgroundColor: 'rgb(251, 191, 180)', height: '20px', width: '20px', }}
                                                            >
                                                                <DeleteRoundedIcon color="error" fontSize={'small'} />
                                                            </IconButton>
                                                        }
                                                    >
                                                        <ListItemText
                                                            primary={element}
                                                            disableTypography={true}
                                                            style={{ fontSize: '10px' }}
                                                        />
                                                    </ListItem>
                                                </Paper>
                                            )
                                        })
                                    }
                                </List >
                            }
                        />
                    }
                </Grid>}

                {/* <Grid item xs={12} marginTop={'25px'}>

                    <Upload maxCount={1} listType="picture" beforeUpload={(file) => handleAddFile(file)}>
                        <Button
                            icon={<UploadOutlined />}
                            iconPosition="end"
                            style={{
                                backgroundColor: "#1F99D2",
                                color: "white",
                                borderRadius: "4px",
                                boxShadow: "1px 1px 3px 1px rgba(0, 0, 0, 0.3)",
                                border: "none",
                                padding: "5px 8px",
                                fontSize: "12px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                            }}
                        >
                            Adicionar Logotipo
                        </Button>
                    </Upload>

                </Grid> */}
            </Grid>
        </FormLayout>
    );
}